<template>
  <div>
    <v-textarea
      :value="value"
      @input="$emit('input', $event)"
      outlined
      dense
      rows="4"
      label="Serial Numbers (one per line)"
      hint="Type or scan one serial number per line — a barcode scanner sends Enter after each scan"
      persistent-hint
      :error-messages="errorMessage ? [errorMessage] : []"
    >
      <template v-slot:append>
        <v-chip small :color="chipColor" dark>
          {{ serials.length }} / {{ quantity || 0 }}
        </v-chip>
      </template>
    </v-textarea>
  </div>
</template>

<script>
import { parseSerials, serialError } from "@/utils/serialNumbers";

export default {
  name: "serialNumbersInput",
  props: {
    value: { type: String, default: "" },
    quantity: { type: [Number, String], default: 0 },
  },
  computed: {
    serials() {
      return parseSerials(this.value);
    },
    errorMessage() {
      if (this.serials.length === 0) return null;
      return serialError(this.serials, this.quantity);
    },
    chipColor() {
      return serialError(this.serials, this.quantity) ? "orange" : "green";
    },
  },
};
</script>
